import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../components/common/Button/Button';
import { CheckText } from '../../../components/common/CheckText';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { color, lightTheme } from '../../../styles/GlobalStyles';
import { CalculatorIcon, Icon, IconWarningMark } from '../../../styles/Icons';
import { ConversionStepsEnum } from './types';
import { CaptionText, H1, H2, P1, P2 } from '../../../styles/FontStyles';
import { LP, formatUSD } from '../../../helpers/helperFunctions';
import { ErrorToast } from '../../../components';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { convertHubToLP } from '../Portfolio.actions';
import moment from 'moment';

interface Step3Props {
  setConversionStep: Dispatch<SetStateAction<ConversionStepsEnum>>;
}

export const Step3 = ({ setConversionStep }: Step3Props) => {
  const { t } = useTranslation('my_hubs');
  const dispatch = useAppDispatch();

  const { conversionUserPackageId, conversionInfo, loadingConversion } =
    useAppSelector((state) => state.portfolio);

  const handleConvert = () => {
    if (conversionUserPackageId === null) return;
    dispatch(
      convertHubToLP({
        userPackageId: conversionUserPackageId,
        setConversionStep
      })
    );
  };

  return (
    <>
      <Box gray>
        <Flexed column center>
          <Flexed>
            <Icon mb='12'>
              <CalculatorIcon />
            </Icon>
          </Flexed>
        </Flexed>

        <P2 bold center mb='4'>
          FINAL STEP
        </P2>
        <P2 mb='20' semiBold center color={lightTheme.colors.neutral500}>
          CONFIRM CONVERSION TO LOYALTY POINTS
        </P2>

        <CaptionText mb='20' center color={lightTheme.colors.neutral500}>
          I am aware that I will convert my Hub NFT into{' '}
          <span style={{ color: lightTheme.colors.primary900 }}>
            {formatUSD(conversionInfo?.amount)} {LP}
          </span>{' '}
          that I can use to purchase any BigWhale product until{' '}
          {moment.utc(conversionInfo?.limitDate).format('MMM DD, yyyy - hh:mm')}{' '}
          UTC.
        </CaptionText>

        <P2 bold center mb='4'>
          RECEIVE
        </P2>
        <H2 mb='4' center color={lightTheme.colors.primary900}>
          {formatUSD(conversionInfo?.amount)} {LP}
        </H2>

        <Button mt='20' onClick={handleConvert} disabled={loadingConversion}>
          CONVERT TO LP
        </Button>
      </Box>
    </>
  );
};
